
//  Link media
require.context('../media/', true, /^\.\/.*\.*/);
require.context('../fonts/', true, /^\.\/.*\.*/);


//  Styles
import '../styles/styles.scss';

// JS
import $ from 'jquery';

import utils from './proj/utils';
import Tracker from './proj/tracker';
import loadChartbeat from './proj/chartbeat';
import Waypoint from 'Waypoint';
import stickyWaypoints from './proj/waypoints/sticky';
// import triggerWaypoints from './proj/waypoints/triggers';
import triggerWaypoints from './proj/waypoints/triggers-with-videosplayinline';
import handleLazySizes from './proj/handleLazySizes';
import handleContainSizing from './proj/handleContainSizing';
// import createGlobe from './proj/globe/globe';
import InView from './proj/inview';
import Slick from './proj/slick';
import canAutoPlay from 'can-autoplay';
import { CountUp } from './proj/CountUp.min.js';


let Site;
const isMobileDevice = utils.mobileAndTabletCheck();
const isMobile = window.innerWidth < 800 || isMobileDevice;


const playVideoReset = function(vid) {

	var playPromise = vid.play();

	if (playPromise !== undefined) {
		playPromise.then(function() {
			// Automatic playback started!
		}).catch(function(error) {
			vid.muted = true;
			vid.currentTime = 0;
			vid.play();
			// Automatic playback failed.
			// Show a UI element to let the user manually start playback.
		});
	}
};


const playVideo = function(vid) {

	var playPromise = vid.play();

	if (playPromise !== undefined) {
		playPromise.then(function() {
			// Automatic playback started!
		}).catch(function(error) {
			vid.muted = true;
			vid.play();
			// Automatic playback failed.
			// Show a UI element to let the user manually start playback.
		});
	}
};

const pauseVideo = function(vid) {
	vid.pause();
};

const updateVideoSrc = function(vid) {
		const src = vid.getAttribute('data-vid-src');
		const newSrc = (isMobile) ? src.replace(".mp4", "-mob.mp4") : src;
		const hasPoster = vid.getAttribute('data-hasposter');
		if (hasPoster) {
			vid.setAttribute('poster', (isMobile) ? hasPoster + '-mob.jpg' : hasPoster + '.jpg');
		}
		vid.setAttribute('data-src', newSrc);
};

(function ($) {
	'use strict';

	Site = {
		/**
		 * initialize prototype
		 *
		 */
		init: function (elt) {
			var self = this;


			// self.cnnTracker();
			// self.cnnPlayer();
			self.lazySizes();


			// project specific
			self.inviewAnimation();
			self.relatedCarousel();
			
			self.handleVideoSrc();
			self.handleMapSrc();
			self.handleWaypoints();
			self.setupAutoplay();

			self.updateHero();
			// self.updateChapters();
			// self.waypointsChapter();
			// self.dropdownMenu();

			self.adjustMobileOffsets();
			// self.handleGlobe();

			self.initChartbeat();
			self.newWindowLink();
			self.scrollToAnchor();
			
			self.navTitle();
			self.animate_stats();
			self.toggleExpendableContent();
			
			// self.statsCarousel();

			// var table1 = document.querySelector('#table1');
			// Sortable.initTable(table1);

			$('body').addClass('loaded');
			$('.hero').addClass('play-text');

			// self.startIntro();
			$('.scroll-indicator').on('click', function(){
				$('html,body').animate({ scrollTop: $(window).height() - 52 },'slow');
			});

			let waypoints = [];

			$.each( $('.timeline__fig.a-type-right .image'), function(idx, el) {
				// right images
				waypoints.push(
					new Waypoint({
						element: el,
						handler: function(dir) {
							var $el = $(el);
							if( dir === 'down') {
								// $el.addClass('a-reveal-from-right');
								$el.addClass('a-reveal-up-in');
								this.destroy();
							}

						},
						offset: '80%'
					})
				);
			});

			$.each( $('.timeline__fig.a-type-left .image'), function(idx, el) {
				// left images
				waypoints.push(
					new Waypoint({
						element: el,
						handler: function(dir) {
							var $el = $(el);
							if( dir === 'down') {
								// $el.addClass('a-reveal-from-left');
								$el.addClass('a-reveal-up-in');
								this.destroy();
							}

						},
						offset: '80%'
					})
				);
			});


			// window.zoomBounds = (isMobile) ? [0, 0, 1312, 2090] : [0,0,4418,2487];
			const resizeHandler = function() {
				handleContainSizing();
			};

			$(window).on('resize', utils.debounce(resizeHandler, 100) );
			handleContainSizing();

			// $(".js-trigger-resize").on('inview', function(event, isInView) {
			// 	if (isInView) {
			// 		Waypoint.refreshAll();
			// 	}
			// });

		},

		/**
		 * Toggle show more / show less
		 *
		 */
		toggleExpendableContent: function(){
			$('.js-toggleExpend').on('click', function(){
				$(this).parent('.cp-expendable').toggleClass('is-open');
			});
		},

		/**
		 * Nav title
		 *
		 */
		navTitle: function(){

			// $('.nav-title').addClass('is-visible');

			// update dropdown menu when scrolling to new chapters
			var waypoint = new Waypoint({
				element: document.getElementById('waypoint_hero'),
				handler: function(direction) {
					if(direction === 'up') {
						$('.nav-title').removeClass('is-visible');
					} 
					else {
						$('.nav-title').addClass('is-visible');
					}
				},
				offset: '-100%'
			});
		},

		/**
		 * inview animation
		 *
		 */
		 inviewAnimation: function(){
			$("[class*='ivanim-']").on('inview', function(event, isInView) {
				if (isInView) {
					if (!$(this).hasClass('is-inview')) {
						$(this).addClass('is-inview');
					}
				}
			});

			// inview repeat
			$("[class*='ivanimr-']").on('inview', function(event, isInView) {
				if (isInView) {
					if (!$(this).hasClass('is-inview')) {
						$(this).addClass('is-inview');
					}
				}
				else {
					if ($(this).hasClass('is-inview')) {
						$(this).removeClass('is-inview');
					}
				}
			});
		},

		/**
		 * animation on the stats
		 *
		 */
		animate_stats: function (){
			
			// add unique ID to all stats
			var stat_n = 0;
			$('.js-stat-number').each(function(){
				stat_n++;
				$(this).attr('id', 'stat'+stat_n);
			});

			// count up
			$('.js-stat-number').on('inview', function(event, isInView) {
				if (isInView) {
					if (!$(this).hasClass('is-inview')) {
						var $target = $(this);

						$target.addClass('is-inview');

						const id_val = $target.attr('id');
						const number_val = $target.attr('data-number');
						const separator_val = $target.attr('data-separator');
						const prefix_val = $target.attr('data-prefix');
						const suffix_val = $target.attr('data-suffix');
						const decimal_val = $target.attr('data-decimal');
						const duration_val = $target.attr('data-duration');

						const options = {
							prefix: prefix_val, 
							suffix: suffix_val,
							startVal: 0,
							useEasing: false, 
							useGrouping: true, 
							separator: separator_val, 
							decimal: '.', 
							duration: duration_val,
						};
						// let countUpY1 = new CountUp('year1', 2019, optionsY1);
						// countUpY1.start(methodToCallOnComplete);


						const demo = new CountUp(id_val, number_val, options);
						if (!demo.error) {
							demo.start();
						}
					}
				}
				else {

				}
			});
		},

		/**
		 * drop menu
		 *
		 */
		dropdownMenu: function() {
			// dropdown
			$('#dd').on('click', function(event){
				$('body').toggleClass('menu-is-open');
			});
			$('body').on('click', 'aside.menu a', function(){
				$('body').toggleClass('menu-is-open');
			});

			// when the map scroll over show menu
			new Waypoint({
				element: document.getElementById('triggerMenu'),
				handler: function(direction) {
					if( direction === 'down') {
						$('#dd').addClass('is-visible');
					} else {
						$('#dd').removeClass('is-visible');
					}
				},
				context: window,
				offset: 50
			});
		},
		updateHero: function() {

			$('.hero').addClass('show');

			$('.js-toggle-menu').on('click', function(){
				$(this).parent().toggleClass('is-open');
			});

		},


		
		/**
		 * statsCarousel
		 *
		 */
		statsCarousel: function(){
			var self = this;

			var speed_val = 1000;
			var speed_autoplay_val = 6000; 

			$('.stats-slider').slick({
				dots: true,
				arrows: true,
				infinite: true,
				speed: speed_val,
				autoplaySpeed: speed_autoplay_val,
				slidesToShow: 1,
				slide: '.slide',
				centerMode: false,
				fade: true,
				variableWidth: false,
				slidesToScroll: 1,
				autoplay: false,
				responsive: [
					{
						breakpoint: 480,
						settings: {
							arrows: true
						}
					}
					// You can unslick at a given breakpoint now by adding:
					// settings: "unslick"
					// instead of a settings object
				]
			});

			// $('.stats-slider').each(function(){
			// 	$(this).on('inview', function(event, isInView) {
			// 		if (isInView) {
			// 			if (!$(this).hasClass('is-autoplay')) {
			// 				$(this).slick('slickPlay');
			// 			}
			// 		}
			// 	});
			// });
		},
		
		/**
		 * related carousel footer
		 *
		 */
		relatedCarousel: function(){
			const speed_val = 1000;
			const speed_autoplay_val = 4000;

			setTimeout(function(){
				$('.js-related-links').slick({
					dots: true,
					infinite: true,
					speed: speed_val,
					slide: '.js-slide',
					centerMode: true,
					variableWidth: true,
					slidesToScroll: 1,
					autoplay: false,
					responsive: [
						{
							breakpoint: 480,
							settings: {
								centerMode: false,
								arrows: false
							}
						}
						// You can unslick at a given breakpoint now by adding:
						// settings: "unslick"
						// instead of a settings object
					]
				});

				setTimeout( function() {
					window.dispatchEvent( new Event('resize') );
				}, 2000);

			}, 2000);
		},

		startIntro: function() {
			const vidContainer = document.querySelector('.hero__media-video-container');
			const vid = document.querySelector('#hero-video');

			// change src
			vid.setAttribute('src', vid.getAttribute('data-src') );

			// add play listener
			const onPlay = function() {
				vidContainer.className = vidContainer.className + ' fade-in';
				vid.removeEventListener('play', onPlay );

				if($('.hero__content').hasClass('show-fallback')) {
					$('.hero__content').removeClass('show-fallback');
				}
				$('.hero__content').addClass('play-text');

			};
			vid.addEventListener('play', onPlay );
			$('.show-fallback').on('click', function(){
				vid.play();
			});

			

			const onVidReady = (vid) => (event) => {
				// attempt to show title screen if video can't auto play  - Browserstack androind native browser samsung galaxy s5 / CNN app too
				const introPlayPromise = vid.play();


			if (introPlayPromise !== undefined) {
					introPlayPromise.then(function() {
						// Automatic playback started!
					}).catch(function(error) {
						$('.hero__content').addClass('show-fallback show-fallback-error');
					});
				}
			};

			vid.addEventListener('loadedmetadata', onVidReady(vid) );

		},

		handleVideoSrc: function() {

			const vids = document.querySelectorAll("video[data-vid-src]");
			[...vids].forEach( updateVideoSrc );
		},

		handleMapSrc: function() {
			// const imgs = $("img[data-img-src]");
			
			$("img[data-img-src]").each(function(e){
				const src = $(this).attr('data-img-src');
				const newSrc = (isMobile) ? src.replace("desktop", "mobile") : src;
				$(this).attr('src', newSrc);
			});
		},


		handleWaypoints: function() {

			let waypoints = [];
			let waypointContext = window;


			const stickyWithWaypoints = stickyWaypoints( waypoints, waypointContext );
			const stickyMedia = $('.js-sticky');
			$.each( stickyMedia, stickyWithWaypoints );


			// set up all the triggers from paragraphs
			const displayTriggers = $('.js-wp-trigger');
			let displayTriggerWaypoints = triggerWaypoints( waypoints, waypointContext );
			$.each( displayTriggers, displayTriggerWaypoints );

		},

		// handleGlobe: function() {
		// 	const globe = createGlobe('#js-globe');
		// },

		setupAutoplay: function() {
			

			const waypointContext = window;
			const autoplayLoops = $('.js-video-play-in-view');
			let waypoints = [];
			$.each(autoplayLoops, function(idx, el) {


				const $el = $(el);
				const vidId = $el.attr('id');
				const vid = document.getElementById(vidId);


				// container enters viewport (scrolling down) or leaves viewport (scrolling back up)
				waypoints.push(
					new Waypoint({
						element: el,
						handler: function(direction) {
						if( direction === 'down' && vid ) {
							if(!$(vid).attr('src')) {
								vid.setAttribute('src', vid.getAttribute('data-src') );
							}

							if($(this).hasClass('js-video-reset')) {
								playVideoReset( vid );
							}
							else {
								playVideo( vid );
							}
						} else {
							if($(this).hasClass('js-video-reset')) {
								pauseVideoReset(vid);
							}
							else {
								pauseVideo(vid);
							}
						}
						},
						context: waypointContext,
						offset: '100%'
					})
				);

				// container exits (scrolling down) or enters (scrolling back up)
				waypoints.push(
					new Waypoint({
						element: el,
						handler: function(direction) {
						if( direction === 'down' && vid ) {
							pauseVideo(vid);
						} else {
							playVideoReset( vid );
						}
						},
						context: waypointContext,
						offset: function() { return -this.element.clientHeight; }
					})
				);

			});
		},

		/**
		 * CNN page view trackers
		 *
		 */
		cnnTracker: function(){

		},

		/**
		 * Image lazy sizes
		 *
		 */
		lazySizes: function(){
			handleLazySizes( this.onImageLoaded.bind(this) );
		},

		onImageLoaded: function(id) {
			if( id === 'splash' ) {
				setTimeout( function() {
					$('.intro-header').addClass('show');
				}, 100);
			}
		},

		/**
		 * Scroll to
		 *
		 */
		scrollToAnchor: function () {

			$('body').on('click', '.scrollTo', function(event){
				event.preventDefault();
				event.stopPropagation();

				var tag = $(this).attr('href');
				$('html,body').animate({scrollTop: $(tag).offset().top - 50},'slow');
			});
		},

		adjustMobileOffsets: function() {
			if( !isMobile ) { return false; }

			const items = [...document.querySelectorAll('[data-mobile-offset]')];
			items.forEach( (item) => {
				item.setAttribute('data-offset', item.getAttribute('data-mobile-offset') );
			})
		},


		/**
		 * Image lazy sizes
		 *
		 */
		initChartbeat: function(){
			// relies on global set in head
			if( window.CNN && window.CNN.omniture && window.CNN.omniture.section ) {
				loadChartbeat( window.CNN.omniture.section[0], "CNN Interactives");
			}

		},

		/**
		 * Open links in new window
		 *
		 */
		newWindowLink: function () {

			$('.cp-text a[href]').each(function() {

				if(!$(this).attr('href').indexOf('cnn') != -1) {
					$(this).attr('target','_blank');
				}
			});
		},


		/**
		 * CNN page view trackers
		 *
		 */
		cnnPlayer: function(){
			if( FAVEPlayer ) {
				FAVEPlayer.create($('.fave'));
			}
		},

	};


	$(document).ready( function(){
		Site.init();
	})

})(jQuery);



// WEBPACK FOOTER //
// ./src/js/main.js